import { render } from "./FuncxFolha.vue?vue&type=template&id=ddbb29f8"
import script from "./FuncxFolha.vue?vue&type=script&lang=js"
export * from "./FuncxFolha.vue?vue&type=script&lang=js"

import "./FuncxFolha.vue?vue&type=style&index=0&id=ddbb29f8&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__